import { useMemo } from "react";

import { DELETABLE_EMAIL_TYPES, EmailContentType, Emptyable } from "@simplyk/common";

// eslint-disable-next-line zeffy-linter-frontend/no-cross-layer-imports -- legacy cross-layer import (pre-rule); migrate when touched
import { useCampaignDateRangeLabel } from "../../features/Campaigns/components/CampaignCard/helpers";

import { useTranslate } from "@/common/hooks/useTranslate";

export const useRecipientPlaceholder = ({
  emailType,
  campaignName,
  hasRecipients = false,
  targetedOccurrenceDate,
}: {
  emailType?: Emptyable<EmailContentType>;
  campaignName?: string;
  hasRecipients?: boolean;
  targetedOccurrenceDate?: string;
}) => {
  const { t } = useTranslate();

  const formattedOccurrenceDate = useCampaignDateRangeLabel(
    targetedOccurrenceDate ? new Date(targetedOccurrenceDate) : undefined,
    undefined
  );

  const occurrenceDateFormatted = `${campaignName ? " " : ""}(${targetedOccurrenceDate ? formattedOccurrenceDate : t("dashboard", "EmailDrawer.recipientEmails.allDates")})`;

  const blastPlaceholder = t("dashboard", "EmailDrawer.recipientEmails.blastPlaceholder", {
    campaignName: campaignName || "",
    occurrenceDateFormatted,
  });

  const recipientPlaceholderMap: Partial<Record<EmailContentType, string | undefined>> = useMemo(
    () => ({
      [EmailContentType.REMINDER]: t("dashboard", "EmailDrawer.recipientEmails.eventGuests"),
      [EmailContentType.REMINDER2]: t("dashboard", "EmailDrawer.recipientEmails.eventGuests"),
      [EmailContentType.POST_EVENT]: t("dashboard", "EmailDrawer.recipientEmails.eventGuests"),
      [EmailContentType.FOLLOW_UP]: t("dashboard", "EmailDrawer.recipientEmails.eventFollowup"),
      [EmailContentType.BLAST]: hasRecipients ? undefined : blastPlaceholder,
      [EmailContentType.INVITATION]: undefined,
      [EmailContentType.INCOMPLETE_PAYMENT_FOLLOW_UP]: undefined,
    }),
    [t, hasRecipients, blastPlaceholder]
  );

  return emailType ? recipientPlaceholderMap[emailType] : undefined;
};

export const useIsPlaceholderDeletable = (emailType: Emptyable<EmailContentType>) => {
  return emailType ? DELETABLE_EMAIL_TYPES.includes(emailType) : false;
};
